export enum SubscriptionEmailActionEnum {
  REQUEST = "app/SUBSCRIPTIONEMAIL/REQUEST",
  SUCCESS = "app/SUBSCRIPTIONEMAIL/SUCCESS",
  FAIL = "app/SUBSCRIPTIONEMAIL/FAIL",
  RESET = "app/SUBSCRIPTIONEMAIL/RESET",
  SET_EMAIL = "app/SUBSCRIPTIONEMAIL/SET/EMAIL",
  SET_ISSUBSCRIBED = "app/SUBSCRIPTIONEMAIL/SET/ISSUBSCRIBED",
}

export interface ISubscriptionEmailRequest {
  type: SubscriptionEmailActionEnum.REQUEST;
  email: string;
}
export interface ISubscriptionEmailSuccess {
  type: SubscriptionEmailActionEnum.SUCCESS;
}
export interface ISubscriptionEmailFail {
  type: SubscriptionEmailActionEnum.FAIL;
  err: Error;
}
export interface ISubscriptionEmailReset {
  type: SubscriptionEmailActionEnum.RESET;
}

export interface ISubscriptionEmailSetEmail {
  type: SubscriptionEmailActionEnum.SET_EMAIL;
  email: string;
}
export interface ISubscriptionEmailSetIsSubscribed {
  type: SubscriptionEmailActionEnum.SET_ISSUBSCRIBED;
  isSubscribed: boolean;
}

export type SubscriptionEmailAction =
  | ISubscriptionEmailRequest
  | ISubscriptionEmailSuccess
  | ISubscriptionEmailFail
  | ISubscriptionEmailReset
  | ISubscriptionEmailSetEmail
  | ISubscriptionEmailSetIsSubscribed;

export function subscriptionEmailRequest(
  email: string,
): ISubscriptionEmailRequest {
  return {
    type: SubscriptionEmailActionEnum.REQUEST,
    email,
  };
}
export function subscriptionEmailSuccess(): ISubscriptionEmailSuccess {
  return {
    type: SubscriptionEmailActionEnum.SUCCESS,
  };
}
export function subscriptionEmailFail(err: Error): ISubscriptionEmailFail {
  return {
    type: SubscriptionEmailActionEnum.FAIL,
    err,
  };
}
export function subscriptionEmailReset(): ISubscriptionEmailReset {
  return {
    type: SubscriptionEmailActionEnum.RESET,
  };
}

export function subscriptionEmailSetEmail(
  email: string,
): ISubscriptionEmailSetEmail {
  return {
    type: SubscriptionEmailActionEnum.SET_EMAIL,
    email,
  };
}
export function subscriptionEmailSetIsSubscribed(
  isSubscribed: boolean,
): ISubscriptionEmailSetIsSubscribed {
  return {
    type: SubscriptionEmailActionEnum.SET_ISSUBSCRIBED,
    isSubscribed,
  };
}
